import { render, staticRenderFns } from "./TabBeneficiaryAllAutoTopUpsHistory.vue?vue&type=template&id=1fc8a595&scoped=true"
import script from "./TabBeneficiaryAllAutoTopUpsHistory.vue?vue&type=script&lang=js"
export * from "./TabBeneficiaryAllAutoTopUpsHistory.vue?vue&type=script&lang=js"
import style0 from "./TabBeneficiaryAllAutoTopUpsHistory.vue?vue&type=style&index=0&id=1fc8a595&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc8a595",
  null
  
)

export default component.exports